var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-7 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "two"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.531l-8.344 9.813h10.156v2.25h-15.031l7.969-9.344s3.656-4.219 4-4.75 0.594-1.469 0.594-2.344c0-2.719-2.188-4.938-4.938-4.938-2.719 0-4.938 2.219-4.938 4.938 0 0.813 0.188 1.531 0.531 2.219h-2.313c-0.25-0.719-0.406-1.406-0.406-2.219 0-3.906 3.219-7.125 7.125-7.125 3.656 0 6.656 2.75 7.063 6.313 0.031 0.25 0.031 0.563 0.031 0.813 0 1.656-0.563 3.188-1.5 4.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.830f6d65d6457b8e8bbd20ab06f0147e.svg";
export { ForwardRef as ReactComponent };